import {toast} from "react-toastify";

export function getUniqueDates(dates: Date[]): Date[] {
    const uniqueDates = new Map<number, Date>();
    dates.forEach(date => {
        uniqueDates.set(date.getTime(), date)
    })

    return Array.from(dates.values())
}

/**
 * n달 뒤 동일 날짜 반환
 */
export const getNextNthMonthSameDate = (inputDate: Date, n: number): Date => {
    const nextMonthDate = new Date(inputDate);
    nextMonthDate.setMonth(nextMonthDate.getMonth() + n);

    return nextMonthDate;
};

/**
 * 12:30 형태로 시간 반환
 */
export function getShortenTime(date: Date) {
    const hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
    const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
    return `${hours}:${minutes}`
}

/**
 * 8/31(월) 형태로 날짜 반환
 */
export function getShortenDateWithDayOfWeek(date: Date | null): string {
    if (date == null) {
        return ""
    }
    return `${date.getMonth()+1}/${date.getDate()}(${getKoreanDayOfWeek(date.getDay())})`
}

/**
 * 2024.8.31 형태로 날짜 반환
 */
export function getShortenDateWithYear(date: Date | null): string {
    if (date == null) {
        return "";
    }

    return `${date.getFullYear()}.${date.getMonth()+1}.${date.getDate()}`;
}

/**
 * 2024.8.31 12:30 형태로 일시 반환
 */
export function getShortenDateTimeWithYear(date: Date | null): string {
    if (date == null) {
        return "";
    }

    return `${getShortenDateWithYear(date)} ${getShortenTime(date)}`
}

/**
 * 2024.8.31(월) 형태로 날짜 반환
 */
export function getShortenDateWithDayOfWeekAndYear(date: Date): string {
    return `${date.getFullYear()}.${date.getMonth()+1}.${date.getDate()}(${getKoreanDayOfWeek(date.getDay())})`
}

/**
 * 두 날짜가 같은 날짜인지 비교(시간은 상관 없음)
 */
export function isSameDate(a: Date, b: Date): boolean {
    return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}

export function getKoreanDayOfWeek(dayOfWeekNumber: number): string {
    switch (dayOfWeekNumber) {
        case 0:
            return "일"
        case 1:
            return "월"
        case 2:
            return "화"
        case 3:
            return "수"
        case 4:
            return "목"
        case 5:
            return "금"
        case 6:
            return "토"
        default:
            throw Error("잘못된 요일입니다.")
    }
}

/**
 * 두 날짜가 같은 요일인지 비교
 */
export function isSameDay(a: Date, b: Date): boolean {
    return a.getDay() === b.getDay();
}

export function alfyToast(message: string) {
    toast(message, {
        position: "bottom-center",
        autoClose: 2000,
        theme: "dark",
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        progress: undefined,
    })
}